export const INDICE_LIST = 'INDICE_LIST'
export const INDICE_RANKING = 'INDICE_RANKING'
export const INDICE_PRICE = 'INDICE_PRICE'
export const INDICE_FOLLOWING = 'INDICE_FOLLOWING'
export const INDICE_NAV = 'INDICE_NAV'
export const INDICE_QUOTE = 'INDICE_QUOTE'
export const INDICE_NAV_SHARE = 'INDICE_NAV_SHARE'
export const INDICE_TIMESTAMP_1D = 'INDICE_TIMESTAMP_1D'